<template>
  <ul class="header__nav" :class="{ 'is-open': isMobileMenuOpen }">
    <li>
      <a href="#" @click.prevent="handleHomeClick">{{ $t('navigation.home') }}</a>
    </li>
    <li class="current has-children">
      <a href="javascript:void(0)" title="" @click="toggleSubMenu('categories')">{{ $t('navigation.categories') }}</a>
      <ul class="sub-menu" :style="{ display: isSubMenuOpen('categories') ? 'block' : 'none' }">
        <li v-for="category in displayedCategories" :key="category.id">
          <a href="javascript:void(0)" @click="navigateToCategory(category)">{{ category.name }}</a>
        </li>
        <li v-for="category in extraCategories" :key="category.id" class="more-categories-mobile">
          <a href="javascript:void(0)" @click="navigateToCategory(category)">{{ category.name }}</a>
        </li>
        <li v-if="extraCategories.length > 0" class="more-categories-desktop">
          <a @click="$emit('openCategoryModal')" href="javascript:void(0)">{{ $t('navigation.more_categories_button') }}</a>
        </li>
      </ul>
    </li>

    <li>
      <a href="#" @click.prevent="handleStartupDirectoryClick">{{ $t('navigation.startup_directory') }}</a>
    </li>

    <li>
      <a href="#" @click.prevent="handleTechEventsClick">{{ $t('navigation.tech_events') }}</a>
    </li>

    <!-- Newsletter (Subscribe + Manage Subscription) -->
    <li class="has-children">
      <a href="javascript:void(0)" title="" @click="toggleSubMenu('newsletter')">{{ $t('navigation.newsletter') }}</a>
      <ul class="sub-menu" :style="{ display: isSubMenuOpen('newsletter') ? 'block' : 'none' }">
        <li>
          <a href="#" @click.prevent="handleSubscribeClick">{{ $t('navigation.subscribe') }}</a>
        </li>
        <li>
          <a href="#" @click.prevent="handleManageSubscriptionClick">{{ $t('navigation.manage_subscription') }}</a>
        </li>
      </ul>
    </li>

    <li class="has-children">
      <a href="javascript:void(0)" title="" @click="toggleSubMenu('language')">{{ $t('navigation.language') }}</a>
      <ul class="sub-menu" :style="{ display: isSubMenuOpen('language') ? 'block' : 'none' }">
        <li @click="emitChangeLocale('en')"><a href="javascript:void(0);">{{ $t('language.en') }}</a></li>
        <li @click="emitChangeLocale('fr')"><a href="javascript:void(0);">{{ $t('language.fr') }}</a></li>
      </ul>
    </li>

    <li>
      <a href="#" @click.prevent="handleContactClick">{{ $t('navigation.contact') }}</a>
    </li>
  </ul>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  props: {
    displayedCategories: Array,
    extraCategories: Array,
    isMobile: Boolean
  },
  emits: ['closeMenu'],
  setup(props, { emit }) {
    const router = useRouter();
    const openSubMenus = ref(['categories']);
    const isMobileMenuOpen = ref(false);

    const handleSubscribeClick = () => {
      // Close the menu if it's open
      isMobileMenuOpen.value = false;
      // Emit close menu event
      emit('closeMenu');
      router.push({ name: 'SubscribePage' });
    };

    const handleManageSubscriptionClick = () => {
      // Close the menu if it's open
      isMobileMenuOpen.value = false;
      // Emit close menu event
      emit('closeMenu');
      router.push({ name: 'RequestSubscriptionMagicLinkPage' });
    };

    const toggleSubMenu = (menu) => {
      if (openSubMenus.value.includes(menu)) {
        openSubMenus.value = openSubMenus.value.filter(m => m !== menu);
      } else {
        openSubMenus.value.push(menu);
      }
    };

    const isSubMenuOpen = (menu) => {
      return openSubMenus.value.includes(menu);
    };

    const navigateToCategory = (category) => {
      isMobileMenuOpen.value = false;
      emit('closeMenu');
      router.push({ name: 'PostsPerCategoryPage', params: { slug: category.slug } });
    };

    const handleHomeClick = () => {
      isMobileMenuOpen.value = false;
      emit('closeMenu');
      router.push({ name: 'HomePage' });
    };

    const handleContactClick = () => {
      isMobileMenuOpen.value = false;
      emit('closeMenu');
      router.push({ name: 'ContactPage' });
    };

    const handleStartupDirectoryClick = () => {
      isMobileMenuOpen.value = false;
      emit('closeMenu');
      router.push({ name: 'StartupsPage' });
    };

    const handleTechEventsClick = () => {
      isMobileMenuOpen.value = false;
      emit('closeMenu');
      router.push({ name: 'TechEventsPage' });
    };

    const emitChangeLocale = (locale) => {
      const url = new URL(window.location.href);
      url.searchParams.set('lang', locale);
      window.location.href = url.toString();
    };

    return {
      openSubMenus,
      isMobileMenuOpen,
      isSubMenuOpen,
      toggleSubMenu,
      navigateToCategory,
      handleHomeClick,
      handleContactClick,
      handleStartupDirectoryClick,
      handleTechEventsClick,
      handleSubscribeClick,
      handleManageSubscriptionClick,
      emitChangeLocale
    };
  }
};
</script>

<style>
.el-select__selection {
  min-height: 35px!important;
  height:auto!important;
}

/* Hide more categories button by default (mobile view) */
.more-categories-desktop {
  display: none !important;
}

/* Show extra categories on mobile by default */
.more-categories-mobile {
  display: block !important;
}

/* Show more categories button and hide extra categories on desktop viewport */
@media screen and (min-width: 769px) {
  .more-categories-desktop {
    display: block !important;
  }
  .more-categories-mobile {
    display: none !important;
  }
}
</style>